import React from 'react';
import { Link } from 'react-router-dom';
import { Newspaper } from 'lucide-react';
import ServiceCTA from '../components/ServiceCTA';
import TrustBadge from '../components/TrustBadge';

// お知らせ記事データ（今後の記事追加が容易な配列構成）
const newsArticles = [
  {
    id: 'tiktok-live-official-agency',
    date: '2026年2月',
    category: 'お知らせ',
    title: 'TikTok LIVE公認エージェンシー認定のお知らせ',
    body: [
      'この度、さくらグローバル合同会社はTikTok LIVE公認エージェンシーとして認定されました。',
      'SLBSでは、この認定を活かし、地域事業者様やクリエイターの皆様に向けて、TikTok LIVEを活用した情報発信、集客、販路拡大、地域プロモーションをより充実した形でサポートしてまいります。',
      '私たちは、ライブ配信を通じて地域の魅力や商品・サービスをより多くの方へ届け、新しいデジタル活用の可能性をご提案してまいります。',
      '今後とも、Sakura Local Business Supportをよろしくお願いいたします。',
    ],
    highlight: true,
  },
];

const News = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-4 fade-in">
            <Newspaper className="w-12 h-12 mx-auto mb-4" style={{ color: '#F7C9D3' }} />
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
              お知らせ
            </h1>
            <p className="text-xl text-gray-700">
              SLBSからの最新情報をお届けします。
            </p>
          </div>
        </div>
      </section>

      {/* News List */}
      <section className="pb-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto space-y-8">
            {newsArticles.map((article) => (
              <article
                key={article.id}
                data-testid={`news-article-${article.id}`}
                className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border border-gray-100"
              >
                <div className="flex flex-wrap items-center gap-3 mb-4">
                  <span className="text-sm text-gray-500">{article.date}</span>
                  <span
                    className="text-xs font-medium px-3 py-1 rounded-full"
                    style={{ backgroundColor: '#FFF7FA', color: '#C77A93' }}
                  >
                    {article.category}
                  </span>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                  {article.title}
                </h2>
                {article.highlight && <TrustBadge className="mb-6" />}
                <div className="space-y-4">
                  {article.body.map((paragraph, index) => (
                    <p key={index} className="text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
                <div className="mt-8">
                  <Link
                    to="/services/tiktok-live"
                    className="inline-block text-sm text-[#C77A93] hover:text-[#2C2C2C] font-medium"
                  >
                    TikTok LIVE・ライブ配信サポートについて →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <ServiceCTA
        title="お気軽にご相談ください"
        description="TikTok LIVEやデジタル活用について、まずはお話をお伺いいたします。"
        buttonText="無料相談はこちら"
      />
    </div>
  );
};

export default News;
